import { actionCreation } from '@anna/anna-ws-utils';

const { generateActionTypes, generateActions } = actionCreation;

export const requestZipActionTypes = generateActionTypes('REQUEST_ZIP');
export const requestZipCheckStatusActionTypes = generateActionTypes('REQUEST_ZIP_CHECK_STATUS');
export const downloadZipActionTypes = generateActionTypes('DOWNLOAD_ZIP');

export const requestZipActions = generateActions(requestZipActionTypes, {
  success: ['requestId'],
});

export const requestZipCheckStatusActions = generateActions(requestZipCheckStatusActionTypes, {
  success: ['status'],
});

export const downloadZipActions = generateActions(downloadZipActionTypes, {
  common: ['downloadUrl'],
});
